import { Pipe, PipeTransform } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';
import { CalendarEventTitleFormatter } from '../providers/calendarEventTitleFormatter.provider';


export class CalendarEventTitlePipe implements PipeTransform {

  constructor(private calendarEventTitle: CalendarEventTitleFormatter) {}

  transform(title: string, titleType: string, event: CalendarEvent): string {
    return this.calendarEventTitle[titleType](event);
  }

static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'calendarEventTitle'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CalendarEventTitleFormatter, },
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
